interface SegProps<V extends string> {
  value: V;
  onChange: (v: V) => void;
  options: ReadonlyArray<readonly [V, string]>;
}

/**
 * Segmented control. Used in Settings, Flashcard direction, etc.
 */
export function Seg<V extends string>({ value, onChange, options }: SegProps<V>) {
  return (
    <div className="seg">
      {options.map(([k, label]) => (
        <button key={k} className={value === k ? "is-on" : ""} onClick={() => onChange(k)} type="button">
          {label}
        </button>
      ))}
    </div>
  );
}
